import React, { useState } from 'react';

const defaultValue = {
  contas: [],
  contasCorrente: [],
  contaAtual: {}, //
  historico: [],
  bancos: [],
  selecao: [],
  tipoSelecao: 'NENHUM',
  loading: false,
  fabHidden: false,
  totalElements: 0,
  modal: '',
  search: '',
  page: 0,
  size: 15,
};

export const ContaContext = React.createContext({});

export const ContaProvider = (props) => {
  return (
    <ContaContext.Provider
      value={{
        contas: useState(defaultValue.contas),
        contasCorrente: useState(defaultValue.contasCorrente),
        contaAtual: useState(defaultValue.contaAtual),
        historico: useState(defaultValue.historico),
        bancos: useState(defaultValue.bancos),
        loading: useState(defaultValue.loading),
        selecao: useState(defaultValue.selecao),
        tipoSelecao: useState(defaultValue.tipoSelecao),
        fabHidden: useState(defaultValue.fabHidden),
        totalElements: useState(defaultValue.totalElements),
        modal: useState(defaultValue.modal),
        search: useState(defaultValue.search),
        page: useState(defaultValue.page),
        size: useState(defaultValue.size),
      }}
    >
      {props.children}
    </ContaContext.Provider>
  );
};

export const ContaConsumer = ContaContext.Consumer;
